import { POS_ROUTE } from "../../../constants/constants";

export const COMPANY_OUTLETS_ROUTE = POS_ROUTE + "/outlets"
export const MANAGE_SINGLE_OUTLETS_ROUTE = POS_ROUTE + "/outlets/manage/:uuid"
export const OUTLET_REGISTERS_ROUTE = POS_ROUTE + "/outlets/:uuid/registers"

export const REGISTERS_STAFF_ROUTE = POS_ROUTE + "/outlets/:uuid/registers/:register_uuid/staff"